import React from 'react';
import {styled} from '@mui/material/styles';
import SocialMediaLinks from './SocialMediaLinks';
import NativeAppLinks from './NativeAppLinks';
import ServiceLinks from './ServiceLinks';
import LegalLinks from './LegalLinks';
import {WhiteTypography} from './FooterSharedStyles';
import {COLORS, SIZES} from '@fupa/fupa-uikit';
import {Section} from '../cards/CardStyles';

const Container = styled('footer')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: ${SIZES['64']} 0 ${SIZES['16']};
`;

const Row = styled('div')`
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding-bottom: ${SIZES['32']};
  flex-wrap: wrap;
  gap: ${SIZES['16']};
`;

const LogoLink = styled('a')`
  display: flex;
  flex-direction: column;
  text-decoration: none;

  img {
    object-fit: contain;
  }
`;

const Footer = () => {
  return (
    <Section primaryGradient backgroundColor={COLORS.fupaPrimary}>
      <Container>
        <Row>
          <ServiceLinks />
          <LegalLinks />
          <div>
            <SocialMediaLinks />
            <NativeAppLinks />
          </div>
        </Row>
        <LogoLink href='https://www.fupa.net' target='_blank'>
          <img src={'/FuPaLogo-white.svg'} alt='Logo von FuPa.net' height='40' width='190' />
          <WhiteTypography variant='caption1'>
            &copy; Copyright 2006 - {new Date().getFullYear()} FuPa GmbH
          </WhiteTypography>
        </LogoLink>
      </Container>
    </Section>
  );
};

export default Footer;
